module.exports = __webpack_public_path__ + "static/img/Caraway.bb0f9ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Caraway.jpg
// module id = zBOJ
// module chunks = 0